module.exports = __webpack_public_path__ + "img/feature-background-4.90562def.png";